var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMesNotViewed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52876 7.52876C3.78911 7.26841 4.21122 7.26841 4.47157 7.52876L7.13823 10.1954C7.39858 10.4558 7.39858 10.8779 7.13823 11.1382C6.87788 11.3986 6.45577 11.3986 6.19542 11.1382L3.52876 8.47157C3.26841 8.21122 3.26841 7.78911 3.52876 7.52876Z",
    fill: "#76768C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4714 4.86177C12.7318 5.12212 12.7318 5.54423 12.4714 5.80457L7.13807 11.1379C6.87772 11.3983 6.45561 11.3983 6.19526 11.1379C5.93491 10.8776 5.93491 10.4554 6.19526 10.1951L11.5286 4.86177C11.7889 4.60142 12.2111 4.60142 12.4714 4.86177Z",
    fill: "#76768C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesNotViewed);
export default __webpack_public_path__ + "static/media/mesNotViewed.6402e68bdff62353fb795473e3bc2750.svg";
export { ForwardRef as ReactComponent };